import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import shared from "./shared.json";
import thgQuote from "./thg-quote.json";
import user from "./user.json";

const registration = {
  ...getI18nJsonProp(shared, "registration"),
  ...getI18nJsonProp(thgQuote, "registration"),
  ...getI18nJsonProp(user, "registration"),
};

export default registration;
